import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { userIdentifierStruct } from "./userIdentifierStruct";

export const userResourceStruct = createResourceStruct({
  identifier: userIdentifierStruct,
  attributes: sup.object({
    firstName: sup.string(),
    lastName: sup.string(),
    // eslint-disable-next-line no-warning-comments
    // TODO: unify response from the backend in task list and subtask details
    avatarUrl: sup.optional(sup.nullable(sup.string())),
  }),
});

export type UserResource = sup.Infer<typeof userResourceStruct>;
